<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight" v-loading="loading">
            <el-row>
              <el-col>
                <el-steps :active="activeStep" process-status="finish" finish-status="success" simple>
                  <el-step title="添加信息" :status="getStepStatus(0)" @click.native="onStepItemClick(0)"></el-step>
                  <el-step title="缴付款项" :status="getStepStatus(1)" @click.native="onStepItemClick(1)"></el-step>
                  <el-step title="购买成功" :status="getStepStatus(2)" @click.native="onStepItemClick(2)"></el-step>
                </el-steps>
              </el-col>
            </el-row>
            <hr />
            <el-row class="grid-content">
              <el-col>
                <ocf-workflow-step1 ref="ocf-workflow-step1" v-show="activeStep === 0"
                  :data="dataForComponents.ocfWorkflowStep1" @next="onNext" @reload="onReload"></ocf-workflow-step1>
                <ocf-workflow-step2 ref="ocf-workflow-step2" v-if="activeStep === 1 || activeStep === 2"
                  :data="dataForComponents.ocfWorkflowStep2" @next="onNext" @reload="onReload"></ocf-workflow-step2>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.el-col {
  span {
    height: 40px;
    line-height: 40px;
  }
}

.el-button {
  margin-left: 20px;
}
</style>

<script>
import navigator from "../../components/navigator";
import ocfWorkflowStep1 from "../../components/addCollectFees/otherCollectFee/ocfWorkflowStep1";
import ocfWorkflowStep2 from "../../components/addCollectFees/otherCollectFee/ocfWorkflowStep2";

import { getGlobalPriceSettings } from "../../service/globalPriceSetting.service";
import {
  getBonusPointMechanismByType,
  getBonusPointExchangeItemList,
} from "../../service/bonusPoint.service";
import {
  createWorkflowModel,
  getWorkflowData,
  saveWorkflowData,
  getGiftBalances,
} from "../../service/otherCollectFee.service";
import {
  createAccountModel,
  getAccount,
} from "../../service/finance.service.js";
import global_ from "../../core/global";
import { getMemberShipYears } from "../../service/common.service";

export default {
  data() {
    return {
      loading: false,
      activeStep: 0,
      currentStep: 0,
      priceSettings: {
        normalVideoPrice: 0,
        supplementVideoPrice: 0,
        membershipCardPrice: 0,
        paymentCommissionRate: 0,
        renewMembershipCardPrice: 0,
        academicPlanningOnce: 0,
        academicPlanningUnlimited: 0,
        afterDiscountMembershipCardPrice: 0,
        extendMembershipCardPrice: 0,
        airportPickUpPrice: 0,
        videoPackagePrice: 0,
        autoEnrollCoursePrice: 0
      },
      bonusPointMechanisms: {
        bonusPointToMoneyRate: 0,
      },
      memberShipYears: [],
      bonusPointExchangeItems: [],
      otherCollectFeeTypes: [],
      workflowData: null,
      accountData: null,
      giftBalanceList: [],
      dataForComponents: {
        ocfWorkflowStep1: {
          priceSettings: null,
          otherCollectFeeTypes: [],
          memberShipYears: [],
          bonusPointMechanisms: null,
          bonusPointExchangeItems: [],
          giftBalanceList: [],
          workflowData: null,
        },
        ocfWorkflowStep2: {
          priceSettings: null,
          bonusPointMechanisms: null,
          bonusPointExchangeItems: [],
          giftBalanceList: [],
          otherCollectFeeTypes: [],
          memberShipYears: [],
          workflowData: null,
          accountData: null,
        },
      },
    };
  },
  components: {
    navigator,
    ocfWorkflowStep1,
    ocfWorkflowStep2,
  },
  computed: {
    isStudentTopUpBalance() {
      if (!this.USERMANAGER.isStudent) return false;
      return this.$route.name === "addCollectFeesTopUpBalance";
    }
  },
  async created() {
    await this.initBasicData();
    await this.initData();
  },
  methods: {
    async loadPriceSettingsFromServer() {
      let gpTypes = [
        this.GLOBAL.globalPriceType.normalVideoPrice,
        this.GLOBAL.globalPriceType.supplementVideoPrice,
        this.GLOBAL.globalPriceType.membershipCardPrice,
        this.GLOBAL.globalPriceType.paymentCommissionRate,
        this.GLOBAL.globalPriceType.renewMembershipCardPrice,
        this.GLOBAL.globalPriceType.academicPlanningOnce,
        this.GLOBAL.globalPriceType.academicPlanningUnlimited,
        this.GLOBAL.globalPriceType.renewMembershipCardPriceDiscount,
        this.GLOBAL.globalPriceType.extendMembershipCardPrice,
        this.GLOBAL.globalPriceType.airportPickUpPrice,
        this.GLOBAL.globalPriceType.videoPackagePrice,
        this.GLOBAL.globalPriceType.autoEnrollCoursePrice,
      ];
      let result = await getGlobalPriceSettings(gpTypes);
      if (!!result && result.success) {
        this.priceSettings.normalVideoPrice = this.__findPriceByType(
          result.data,
          this.GLOBAL.globalPriceType.normalVideoPrice
        );
        this.priceSettings.supplementVideoPrice = this.__findPriceByType(
          result.data,
          this.GLOBAL.globalPriceType.supplementVideoPrice
        );
        this.priceSettings.membershipCardPrice = this.__findPriceByType(
          result.data,
          this.GLOBAL.globalPriceType.membershipCardPrice
        );
        this.priceSettings.paymentCommissionRate = this.__findPriceByType(
          result.data,
          this.GLOBAL.globalPriceType.paymentCommissionRate
        );
        this.priceSettings.renewMembershipCardPrice = this.__findPriceByType(
          result.data,
          this.GLOBAL.globalPriceType.renewMembershipCardPrice
        );
        this.priceSettings.academicPlanningOnce = this.__findPriceByType(
          result.data,
          this.GLOBAL.globalPriceType.academicPlanningOnce
        );
        this.priceSettings.academicPlanningUnlimited = this.__findPriceByType(
          result.data,
          this.GLOBAL.globalPriceType.academicPlanningUnlimited
        );
        this.priceSettings.afterDiscountMembershipCardPrice = this.__findPriceByType(
          result.data,
          this.GLOBAL.globalPriceType.afterDiscountMembershipCardPrice
        );
        this.priceSettings.extendMembershipCardPrice = this.__findPriceByType(
          result.data,
          this.GLOBAL.globalPriceType.extendMembershipCardPrice
        );
        this.priceSettings.airportPickUpPrice = this.__findPriceByType(
          result.data,
          this.GLOBAL.globalPriceType.airportPickUpPrice
        );
        this.priceSettings.videoPackagePrice = this.__findPriceByType(
          result.data,
          this.GLOBAL.globalPriceType.videoPackagePrice
        );
        this.priceSettings.autoEnrollCoursePrice = this.__findPriceByType(
          result.data,
          this.GLOBAL.globalPriceType.autoEnrollCoursePrice
        );
      } else {
        this.priceSettings.normalVideoPrice = 0;
        this.priceSettings.supplementVideoPrice = 0;
        this.priceSettings.membershipCardPrice = 0;
        this.priceSettings.paymentCommissionRate = 0;
        this.priceSettings.renewMembershipCardPrice = 0;
        this.priceSettings.academicPlanningOnce = 0;
        this.priceSettings.academicPlanningUnlimited = 0;
        this.priceSettings.afterDiscountMembershipCardPrice = 0;
        this.priceSettings.extendMembershipCardPrice = 0;
        this.priceSettings.airportPickUpPrice = 0;
        this.priceSettings.videoPackagePrice = 0;
        this.priceSettings.autoEnrollCoursePrice = 0;
      }

      let yearsResult = await getMemberShipYears(2);
      if (!!yearsResult && yearsResult.success) {
        if (yearsResult.data.length > 0) {
          for (let i = 0; i < yearsResult.data.length; i++) {
            this.memberShipYears.push({
              value: yearsResult.data[i].Value,
              description: yearsResult.data[i].Description,
            });
          }
        }
      } else {
        this.memberShipYears = [];
      }
    },
    async loadBonusPointMechanismsFromServer() {
      let result = await getBonusPointMechanismByType(
        this.GLOBAL.bonusPointMechanismType.bonusPointToMoney
      );
      if (!!result && result.success) {
        this.bonusPointMechanisms.bonusPointToMoneyRate =
          result.data.Money / result.data.BonusPoint;
      } else {
        this.bonusPointMechanisms.bonusPointToMoneyRate = 0;
      }
    },
    async loadBonusPointExchangeItemsFromServer() {
      let result = await getBonusPointExchangeItemList();
      if (!!result && result.success) {
        this.bonusPointExchangeItems = result.data;
      } else {
        this.bonusPointExchangeItems = [];
      }
    },
    async loadGiftBalances() {
      let result = await getGiftBalances();
      if (!!result && result.success) {
        this.giftBalanceList = result.data;
      } else {
        this.giftBalanceList = [];
      }
    },
    async loadWorkflowDataFromServer() {
      let query = this.$route.query;
      let defaultType = `${query.type}`.toNumber();
      if (!defaultType) {
        defaultType = this.otherCollectFeeTypes.length > 0 ? this.otherCollectFeeTypes[0].value : 1;
      }
      let defaultPhone = query.phone;
      let defaultYear =
        this.memberShipYears.length > 0 ? this.memberShipYears[0].value : 0;
      let defaultCourseId = `${query.courseId}`.toNumber();
      this.workflowData = createWorkflowModel(defaultType, defaultPhone, defaultYear, defaultCourseId);
    },
    async loadAccountDataFromServer() {
      this.accountData = createAccountModel();
    },
    loadOtherCollectFeeTypesFromGlobal() {
      let newTypes = [];

      let exceptFields = ["watchVideos"];
      for (let fieldName in this.GLOBAL.otherCollectFeeType) {
        if (exceptFields.contains(fieldName)) {
          continue;
        }

        let isAdd = false;
        if (fieldName == "bonusPointExchangeItem") {
          if (
            this.USERMANAGER.isAdmin ||
            this.USERMANAGER.isFinancialManager ||
            this.USERMANAGER.isExecutiveManager
          ) {
            isAdd = true;
          }
        } else {
          isAdd = true;
        }

        if (isAdd) {
          let field = this.GLOBAL.otherCollectFeeType[fieldName];
          newTypes.push({
            name: fieldName,
            value: field.value,
            description: field.description,
            needStudent: field.needStudent,
          });
        }
      }
      this.otherCollectFeeTypes = newTypes;
    },
    async initBasicData() {
      await this.loadPriceSettingsFromServer();
      await this.loadBonusPointMechanismsFromServer();
      await this.loadBonusPointExchangeItemsFromServer();
      await this.loadGiftBalances();
      this.loadOtherCollectFeeTypesFromGlobal();
    },
    async initData() {
      this.activeStep = 0;
      this.currentStep = 0;

      await this.loadWorkflowDataFromServer();
      await this.loadAccountDataFromServer();
      this.reloadDataForAllComponents();
    },
    getStepStatus(step) {
      let stepStatus = "finish";

      if (step != this.activeStep) {
        stepStatus = "process";
        if (step < this.currentStep) {
          stepStatus = "success";
        } else if (step > this.currentStep) {
          stepStatus = "wait";
        } else if (this.currentStep === 2 && step === 2) {
          stepStatus = "success";
        }
      }

      return stepStatus;
    },
    reloadDataForAllComponents() {
      this.reloadDataForStep1();
      this.reloadDataForStep2();
    },
    reloadDataForStep1() {
      let newData = {
        priceSettings: null,
        otherCollectFeeTypes: [],
        memberShipYears: [],
        bonusPointMechanisms: null,
        bonusPointExchangeItems: [],
        giftBalanceList: [],
        workflowData: null,
      };

      newData.priceSettings = this.priceSettings;
      newData.otherCollectFeeTypes = this.otherCollectFeeTypes;
      newData.memberShipYears = this.memberShipYears;
      newData.bonusPointMechanisms = this.bonusPointMechanisms;
      newData.bonusPointExchangeItems = this.bonusPointExchangeItems;
      newData.giftBalanceList = this.giftBalanceList;
      newData.workflowData = this.workflowData;

      this.dataForComponents.ocfWorkflowStep1 = newData;
    },
    reloadDataForStep2() {
      let newData = {
        priceSettings: null,
        bonusPointMechanisms: null,
        bonusPointExchangeItems: [],
        giftBalanceList: [],
        otherCollectFeeTypes: [],
        memberShipYears: [],
        workflowData: null,
        accountData: null,
      };

      newData.priceSettings = this.priceSettings;
      newData.bonusPointMechanisms = this.bonusPointMechanisms;
      newData.bonusPointExchangeItems = this.bonusPointExchangeItems;
      newData.giftBalanceList = this.giftBalanceList;
      newData.otherCollectFeeTypes = this.otherCollectFeeTypes;
      newData.memberShipYears = this.memberShipYears;
      newData.workflowData = this.workflowData;
      newData.accountData = this.accountData;

      this.dataForComponents.ocfWorkflowStep2 = newData;
    },
    updateDataForStep1(dataOut) {
      if (!dataOut) return;

      this.workflowData.Type = dataOut.data.type;
      this.workflowData.FeeYear = dataOut.data.feeYear;
      this.workflowData.SubType = dataOut.data.subType;
      this.workflowData.StudentId = dataOut.data.studentId;
      this.workflowData.Phone = dataOut.data.phone;
      this.workflowData.Comment = dataOut.data.comment;
      this.workflowData.Amount = dataOut.data.amount;
      this.workflowData.Quantity = dataOut.data.quantity;
      this.workflowData.TotalPrice = dataOut.data.totalPrice;
      if (
        dataOut.data.type ==
        this.GLOBAL.otherCollectFeeType.bonusPointExchangeItem.value
      ) {
        this.workflowData.BonusPointExchangeItemId = dataOut.data.bpeItemId;
        this.workflowData.BonusPointCost = dataOut.data.bonusPointCost;
        this.workflowData.BonusPointPrice = dataOut.data.amount;
        this.workflowData.BalanceCost = 0;
        this.workflowData.CashDecreasedAmount = 0;
      } else {
        this.workflowData.BonusPointExchangeItemId = null;
        this.workflowData.BonusPointCost = 0;
        this.workflowData.BonusPointPrice = 0;
        this.workflowData.BalanceCost = 0;
        this.workflowData.CashDecreasedAmount = 0;
      }
      if (
        dataOut.data.type == this.GLOBAL.otherCollectFeeType.topUpBalance.value
      ) {
        this.workflowData.GiftAmount = dataOut.data.giftAmount;
        this.workflowData.GiftBalanceId = dataOut.data.giftBalanceId;
      } else {
        this.workflowData.GiftAmount = null;
        this.workflowData.GiftBalanceId = null;
      }
      if (dataOut.data.type == this.GLOBAL.otherCollectFeeType.videoPackage.value) {
        this.workflowData.CourseId = dataOut.data.courseId;
      } else {
        this.workflowData.CourseId = null;
      }
      this.reloadDataForStep1();

      this.accountData = createAccountModel();
      let accountType = 0;

      switch (dataOut.data.type) {
        case this.GLOBAL.otherCollectFeeType.memberCard.value:
          accountType = this.GLOBAL.accountType.memberCard;
          break;
        case this.GLOBAL.otherCollectFeeType.renewMemberCard.value:
          accountType = this.GLOBAL.accountType.renewMemberCard;
          break;
        case this.GLOBAL.otherCollectFeeType.watchVideos.value:
          accountType = this.GLOBAL.accountType.watchVideos;
          break;
        case this.GLOBAL.otherCollectFeeType.bonusPointExchangeItem.value:
          accountType = this.GLOBAL.accountType.bonusPointExchangeItem;
          break;
        case this.GLOBAL.otherCollectFeeType.academicPlanning.value:
          accountType = this.GLOBAL.accountType.academicPlanning;
          break;
        case this.GLOBAL.otherCollectFeeType.topUpBalance.value:
          accountType = this.GLOBAL.accountType.topUpBalance;
          break;
        case this.GLOBAL.otherCollectFeeType.extendMemberCard.value:
          accountType = this.GLOBAL.accountType.extendMemberCard;
          break;
        case this.GLOBAL.otherCollectFeeType.airportPickUp.value:
          accountType = this.GLOBAL.accountType.airportPickUp;
          break;
        case this.GLOBAL.otherCollectFeeType.videoPackage.value:
          accountType = this.GLOBAL.accountType.videoPackage;
          break;
        case this.GLOBAL.otherCollectFeeType.autoEnrollCourse.value:
          accountType = this.GLOBAL.accountType.autoEnrollCourse;
          break;
      }
      this.accountData.AccountType = accountType;
      this.accountData.StudentId = dataOut.data.studentId;
      this.accountData.StudentPhone = dataOut.data.phone;
      this.accountData.Amount = dataOut.data.totalPrice;
      this.reloadDataForStep2();
    },
    updateDataForStep2(dataOut) {
      if (!dataOut) return;
      this.workflowData.CashDecreasedAmount = dataOut.data.cashDecreasedAmount;
      this.workflowData.BalanceCost = dataOut.data.balanceCost;
      this.workflowData.BonusPointCost = dataOut.data.bonusPointCost;
      this.workflowData.BonusPointPrice = dataOut.data.bonusPointPrice;
      this.workflowData.PaymentCommissionCost =
        dataOut.data.paymentCommissionCost;

      $.extend(true, this.accountData, dataOut.accountData);

      this.reloadDataForStep2();
    },
    onStepItemClick(step) {
      if (step === this.activeStep || step > this.currentStep) return;

      if (
        !this.workflowData ||
        !this.accountData ||
        this.workflowData.IsCompleted
      ) {
        this.activeStep = step;
        return;
      }

      let hasDataChange = false;
      switch (this.activeStep) {
        case 0:
          if (!!this.$refs["ocf-workflow-step1"])
            hasDataChange = this.$refs["ocf-workflow-step1"].hasDataChange();
          break;
        case 1:
          if (!!this.$refs["ocf-workflow-step2"])
            hasDataChange = this.$refs["ocf-workflow-step2"].hasDataChange();
          break;
      }

      if (hasDataChange) {
        this.$confirm("当前步骤的输入值有修改,是否保存?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let dataOut = null;
            try {
              switch (this.activeStep) {
                case 0:
                  if (!!this.$refs["ocf-workflow-step1"])
                    dataOut = this.$refs["ocf-workflow-step1"].getDataOut();
                  if (!!dataOut) this.updateDataForStep1(dataOut);
                  break;
                case 1:
                  if (!!this.$refs["ocf-workflow-step2"])
                    dataOut = this.$refs["ocf-workflow-step2"].getDataOut();
                  if (!!dataOut) this.updateDataForStep2(dataOut);
                  break;
              }
            } catch (error) {
              console.log(error);
            }

            this.activeStep = step;
          })
          .catch(() => {
            this.activeStep = step;
          });
      } else {
        this.activeStep = step;
      }
    },
    async onNext(dataOut) {
      switch (dataOut.stepIndex) {
        case 0:
          this.updateDataForStep1(dataOut);
          break;
        case 1:
          this.updateDataForStep2(dataOut);
          let result = await this.finishWorkflow();
          if (!result) return;
          break;
      }

      if (this.currentStep <= this.activeStep)
        this.currentStep = this.activeStep + 1;
      if (this.activeStep < 2) this.activeStep += 1;
      if (this.activeStep == 2 && !!this.$refs["ocf-workflow-step2"])
        this.$refs["ocf-workflow-step2"].showCompletedDialog();
    },
    async finishWorkflow() {
      if (!this.workflowData || !this.accountData) return false;

      this.loading = true;

      let saveModel = {
        Workflow: $.extend(true, {}, this.workflowData),
        Account: $.extend(true, {}, this.accountData),
      };
      saveModel.Workflow.IsCompleted = true;
      let result = await saveWorkflowData(saveModel);
      if (!result || !result.success) {
        let msgDetail = !!result.message ? `，${result.message}` : String.empty;
        this.$message({
          message: `完成付款失败${msgDetail}`,
          type: "error",
        });
        this.loading = false;
        return false;
      }

      this.workflowData.Id = result.data.WorkflowId;
      this.workflowData.AccountId = result.data.AccountId;
      this.workflowData.IsCompleted = true;
      this.accountData.Id = result.data.AccountId;

      this.reloadDataForStep1();
      this.reloadDataForStep2();

      this.loading = false;

      return true;
    },
    __findPriceByType(gpSettings, type) {
      let result = null;

      for (let i = 0; i < gpSettings.length; i++) {
        let gpSetting = gpSettings[i];

        if (gpSetting.Type === type) {
          result = gpSetting;
          break;
        }
      }

      return result != null ? result.Value : 0;
    },
    onReload() {
      this.$confirm("您确认要新建其他收费流程吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.initData();
        })
        .catch(() => { });
    },
  },
  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/page/addCollectFees/otherCollectFee.vue